import { FC } from 'react';
import styles from './index.module.less';
import { IWholesalePrice } from 'mod/product/interface';
import { Popover } from 'antd';
import { LoopRender } from '@base/snippets/LoopRender';
import cn from 'classnames';
import { useTrans } from 'base/utils/i18n';
import Iconfont from '@base/lib/Iconfont';
import { getUnitsRange } from '@pro/product/utils';

type IWholesalePriceRulesProps = {
    list: IWholesalePrice[];
    activeIndex: number;
    className?: string;
    placement?: 'top' | 'bottom';
};

export const WholesalePriceRules: FC<IWholesalePriceRulesProps> = props => {
    const { className, list, activeIndex, placement = 'bottom' } = props;
    const { t } = useTrans();

    return (
        <Popover
            overlayClassName={styles.popover}
            placement={placement}
            content={
                <>
                    <div>{t('web_wholesale_price_by_quantity')}</div>
                    <LoopRender
                        list={list}
                        render={(item, { index }) => (
                            <div className={cn('flex flex-justify', styles.line, { 'text-muted': index !== activeIndex })}>
                                <span>{getUnitsRange(item)}</span>
                                <span>{item.shopPriceExchangeDisplay}</span>
                            </div>
                        )}
                    />
                </>
            }
        >
            <Iconfont className={cn(className, 'icon-help')}/>
        </Popover>
    )
};
